
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TerraceDetailHeader = () => {
  return (
    <Link to="/" className="inline-flex items-center text-muted-foreground mb-4 hover:text-foreground">
      <ArrowLeft className="w-4 h-4 mr-1" />
      Back to terraces
    </Link>
  );
};

export default TerraceDetailHeader;
